import { z } from 'zod'

const getErrorMessages = (val: string[] | string) => {
  return {
    required: `Pole ${val} jest wymagane.`,
    min: `Pole ${val[0]} musi być dłuższe niż ${val[1]}.`,
    max: `Pole ${val[0]} nie może być dłuższe niż ${val[1]}.`,
    invalid: `Pole ${val} zostało wypełnione niepoprawnie.`,
    checkbox: `Wyraź zgodę żeby przejść dalej.`,
    radio: `Zaznacz ${val} żeby przejść dalej.`,
    select: `Pole ${val} musi zostać wybrane`,
  }
}

const FormSchemas = {
  contact: z.object({
    name: z
      .string({ required_error: getErrorMessages('imię i nazwisko').required })
      .min(2, getErrorMessages(['imię i nazwisko', '2 znaki']).min),
    company: z
      .string({ required_error: getErrorMessages('Firma').required })
      .min(2, getErrorMessages(['Firma', '2 znaki']).min),
    email: z
      .string({
        required_error: getErrorMessages('email').required,
      })
      .email({ message: getErrorMessages('email').invalid }),
    phoneNumber: z
      .string()
      .min(1, getErrorMessages('telefon').required)
      .optional()
      .or(z.literal('')),
    message: z
      .string({ required_error: getErrorMessages('wiadomość').required })
      .min(10, getErrorMessages(['wiadomość', '10 znaków']).min),
    file: z
      .any()
      .optional()
      .refine(
        (file) =>
          file
            ? [
                'image/jpeg',
                'image/jpg',
                'image/png',
                'application/pdf',
              ].includes(file?.type)
            : true,
        'Akceptowane formaty: jpg/jpeg, png, pdf',
      )
      .refine(
        (file) => (file ? file?.size <= 20 * 1024 * 1024 : true),
        'Plik nie może ważyć więcej niż 20mb',
      ),
    agree1: z
      .string()
      .includes('true', { message: getErrorMessages('').checkbox }),
  }),
  career: z.object({
    application: z
      .string({ required_error: getErrorMessages('').required })
      .min(2, getErrorMessages(['', '']).min)
      .optional()
      .or(z.literal('')),
    name: z
      .string({ required_error: getErrorMessages('imię').required })
      .min(2, getErrorMessages(['imię', '2 znaki']).min),
    surname: z
      .string({ required_error: getErrorMessages('nazwisko').required })
      .min(2, getErrorMessages(['nazwisko', '2 znaki']).min),
    phoneNumber: z
      .string()
      .min(1, getErrorMessages('telefon').required)
      .optional()
      .or(z.literal('')),
    email: z
      .string({
        required_error: getErrorMessages('email').required,
      })
      .email({ message: getErrorMessages('email').invalid }),
    cv: z
      .instanceof(File, { message: 'Plik nie został wybrany' })
      .refine((file) => file, 'Plik nie został wybrany')
      .refine(
        (file) =>
          ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'].includes(
            file?.type,
          ),
        'Akceptowane formaty: jpg/jpeg, png, pdf',
      )
      .refine(
        (file) => file?.size <= 20 * 1024 * 1024,
        'Plik nie może ważyć więcej niż 20mb',
      ),
    agree1: z
      .string()
      .includes('true', { message: getErrorMessages('').checkbox }),
  }),
}

export type TSchemasKey = keyof typeof FormSchemas

export type TContact = z.infer<(typeof FormSchemas)['contact']>

export default FormSchemas
